// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3rgjt","resendInfoText":"OnGoingPaymentBox_resendInfoText__2sec_"};